var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, PropertyChangeEventName, Utils, ViewChild } from '@pacem/pacem-core';
import { PacemDataSourceElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemCheckboxListElement = class PacemCheckboxListElement extends PacemDataSourceElement {
    acceptValue(val) {
        // no need to implement
    }
    constructor() {
        super(true);
        this._selectedUiItems = [];
        this['key'] = '_' + Utils.uniqueCode();
    }
    get inputFields() {
        return [];
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'disabled') {
            this._disable.model = val;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._disable.model = this.disabled;
    }
    toggleReadonlyView(readonly) {
        this._span.hidden = !readonly;
        this._repeater.hidden = readonly;
    }
    _selectionChanged(evt, index, item) {
        if (evt.detail.propertyName === 'selected') {
            let ndx, uiItems = this._selectedUiItems;
            if (evt.detail.currentValue === true) {
                uiItems.push(this.datasource[index]);
            }
            else if ((ndx = uiItems.indexOf(this.datasource[index])) !== -1) {
                uiItems.splice(ndx, 1);
            }
        }
    }
    onChange(evt) {
        const val = this.value = this._selectedUiItems.map(i => this.mapEntityToValue(i));
        return Utils.fromResult(val);
    }
};
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemCheckboxListElement.prototype, "_span", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemCheckboxListElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(P + '-data')
], PacemCheckboxListElement.prototype, "_disable", void 0);
PacemCheckboxListElement = __decorate([
    CustomElement({
        tagName: P + '-checkbox-list', template: `<${P}-repeater datasource="{{ :host.adaptedDatasource }}">
    <ol class="${PCSS}-checkbox-list ${PCSS}-viewfinder" pacem>
        <template>
            <li><${P}-checkbox disabled="{{ ::_disable.model || ^item.disabled }}" name="{{ :host.key, once }}" autobind="off" caption="{{ ^item.viewValue }}" true-value="{{ ^item.value }}" selected="{{ :host.isDataSourceItemSelected(^item, :host.value) }}"
on-focus=":host.focusHandler($event)" on-blur=":host.focusHandler($event)"
on-${PropertyChangeEventName}=":host._selectionChanged($event, ^index, ^item)" on-change=":host.changeHandler($event)"></${P}-checkbox></li>
        </template>
    </ol>
</${P}-repeater><span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span><${P}-data></${P}-data><${P}-content></${P}-content>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemCheckboxListElement);
export { PacemCheckboxListElement };
